<div id="prestations">

    <h1>Une éducation par la nature,<br> partout et pour tous.</h1>
    <p>Tu es enseignant, animateur nature, éducateur à l’environnement ou professionnel de la petite enfance ? Tu veux que les enfants vivent des expériences au contact du vivant ?</p>

    <ul class="prestations-wrapper">
        @for(prestation of $typesDePrestations | async;track $index){
        <li>
            <app-carte-prestation [routerLink]="'/prestation/' + prestation.documentId" [prestation]="prestation"></app-carte-prestation>
        </li>
        }
    </ul>

    <a [routerLink]="'/prestations'">voir toutes les activitées</a>
</div>